import { render, staticRenderFns } from "./info-tab.vue?vue&type=template&id=9354f630&"
import script from "./info-tab.vue?vue&type=script&lang=js&"
export * from "./info-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports